export default __webpack_public_path__ + "static/media/ic_messenger.be56d9d3.svg";